import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'
import { SeeCmsCategIconTooltip } from '../SeeIconTooltip'
import { shallowEqual, useSelector } from 'react-redux'
import { omit } from 'lodash'
import categoriesCmsActualitesHelp from 'assets/pictures/observatory/categoriesCmsActualitesHelp.webp'
import categoriesCmsDocumentsHelp from 'assets/pictures/observatory/categoriesCmsDocumentsHelp.webp'
import categoriesCmsFaqHelp from 'assets/pictures/observatory/categoriesCmsFaqHelp.webp'
import cmsReponsesHelp from 'assets/pictures/observatory/cmsReponsesHelp.webp'

const DocumentsParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => {
    const {
        cmsCategories,
    } = useSelector(store => ({
        cmsCategories: store.EventsReducer.cmsCategories,
    }), shallowEqual)

    const formattedCategories = useMemo(() => cmsCategories.map(cc => omit(cc, 'icon')), [cmsCategories])

    return (
        <ParameterCard title={i18n.documents} isGlobal={isGlobal}>
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='categoriesCmsActualites'
                title={i18n.newArticleCategory}
                helpImage={categoriesCmsActualitesHelp}
                iconTooltip={<SeeCmsCategIconTooltip />}
                options={formattedCategories}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='categoriesCmsDocuments'
                title={i18n.documentsArticleCategory}
                helpImage={categoriesCmsDocumentsHelp}
                iconTooltip={<SeeCmsCategIconTooltip />}
                options={formattedCategories}
                multiple
                limit={1}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='categoriesCmsFaq'
                title={i18n.forumArticleCategory}
                helpImage={categoriesCmsFaqHelp}
                iconTooltip={<SeeCmsCategIconTooltip />}
                options={formattedCategories}
            />
            <ParameterWithSwitch
                {...defaultProps}
                parameter='cmsReponses'
                title={i18n.abilityAddTopicsToForum}
                helpImage={cmsReponsesHelp}
            />
        </ParameterCard>
    )
}

DocumentsParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default DocumentsParameters
